import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {environment} from 'src/environments/environment';
import {Observable} from 'rxjs';
import {Company} from './interfaces/company.interface';

export interface CompanyPayload {
    ativo: string;
    dataAlteracao: string;
    desc: boolean;
    nome: string;
    orderBy: 'DataAlteracao';
}

@Injectable({
    providedIn: 'root',
})
export class CompaniesService {
    /**
     * API URL
     * @private
     */
    private readonly apiUrl = environment.apiUrl;

    /**
     * Constructor
     * @param http - Angular Http Client
     */
    constructor(private http: HttpClient) {
    }

    /**
     * [GET] Get all companies
     * @param payload - Company payload interface
     * @param page - Page number
     */
    public getCompanies(payload?: CompanyPayload, page?: number): Observable<any> {
        return (payload && page)
            ? this.http.post(`${this.apiUrl}/empresa/${page}`, payload)
            : this.http.get(`${this.apiUrl}/empresa`);
    }

    /**
     * [GET] Get company by id
     * @param id - Company id
     */
    public getCompany(id: string): Observable<any> {
        return this.http.get(`${this.apiUrl}/empresa/${id}`);
    }

    /**
     * [PUT] Request update company
     * @param companyData - Company interface
     */
    public update(companyData: Company): Observable<any> {
        return this.http.put(`${this.apiUrl}/empresa`, companyData);
    }

    /**
     * [POST] Request post company
     * @param companyData - Company interface
     */
    public create(companyData: Company): Observable<any> {
        return this.http.post(`${this.apiUrl}/empresa`, companyData);
    }

}
